<template>
  <div class="all-style-bgc">
    <div class="text">
      <el-form  size="small" ref="qForm" :inline="true">
        <el-row :gutter="20">
          <el-col :span="14">
            <el-form-item label="联系电话:" >
              <el-input
                v-model="queryTel"
                prefix-icon="el-icon-search"
                placeholder="请输入您原来报装的联系电话"
                @keyup.enter.native="handleFormSubmit(true)"
                style="width: 240px;"
                :clearable="true"/>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleSubmit()">查询</el-button>
              <el-button
                icon="el-icon-refresh"
                @click="handleFormReset">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-top:10px;">
              <a  @click="getloadFile()" style="text-decoration:underline;font-size:18px;">用户报装协议下载</a>
          </el-col>
          <el-col :span="4">
              <el-button
                icon="el-icon-plus"
                type="primary"
                @click="handleAddDone">新建报装工单</el-button>
          </el-col>
        </el-row>
      </el-form> 
      <el-table
        :data="tabledata"
        ref="hTable"
        stripe
        :border="true"
        :height="tableHeight"
        :highlight-current-row="true"
        tooltip-effect="light"
        :header-cell-style="headClass"
        :row-style="{height:'35px'}"
        :cell-style="{padding:'2px'}"
        >

        <el-table-column
          label="用户名称"
          header-align="center"
          prop="USER_NAME"
          min-width="120">
        </el-table-column>

        <el-table-column
          label="联系电话"
          header-align="center"
          prop="USER_PHONE"
          width="120">
        </el-table-column>
        <el-table-column
          label="用户地址"
          header-align="center"
          align="center"
          prop="USER_ADDR"
          :show-overflow-tooltip="true"
          min-width="220">
        </el-table-column>
      <el-table-column
          label="报装时间"
          header-align="center"
          align="center"
          prop="DO_TIME"
          width="170">
      </el-table-column>

      <el-table-column
        label="报装状态"
        header-align="center"
        align="center"
        prop="DO_FLAG"
        width="85">
      </el-table-column>

      <!-- <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="200">
        <template slot-scope="scope">
          <el-tooltip effect="light">
            <div slot="content">
                点击查询详细信息
            </div>
            <el-button
              @click="handleView(scope.$index)"
              size="medium"
              type="text">
              查询
            </el-button>
          </el-tooltip>
          <el-button
            v-if="auth.del"
            @click="handleDelete(scope.$index)"
            size="medium"
            type="text">删除</el-button>
        </template>
      </el-table-column> -->
      </el-table>
      <edit-dialog ref="editForm"
        :visible.sync="dialogVisible"
        @on-visible="changeVisible"
      >
      </edit-dialog>
    </div>
  </div>
</template>
<script>

import util from '@/utils/util'
import constApp from '@/const/constApp'
import { doUserRegQuery,downLoadFile } from '@/api/Hall/xagl'

export default {

  components: {
    'editDialog': () => import('@/views/hall/components/UserAdd/PageAdd')
  },
  data() {
    return {
      loading: true,
      dialogVisible: false,
      tableHeight: 300,
      queryTel: undefined,
      tabledata: [],
    }
  },
  mounted() {
    this._setTableHeight()
  },
  methods: {
    headClass() {
      return 'height:45px;padding:3px;background:#F1F5F8;'
      // return util.css.talbe_headClass()
    },
    _setTableHeight() {
      this.$nextTick(function() {
        this.tableHeight = window.innerHeight - this.$refs.hTable.$el.offsetTop - constApp.TableHeigtSub
        // 监听窗口大小变化
        let self = this
        window.onresize = function() {
          self.tableHeight = window.innerHeight - self.$refs.hTable.$el.offsetTop - constApp.TableHeigtSub
        }
      })
    },
    handleFormReset() {
      this.queryTel = undefined
    },
    changeVisible(val) {
      this.dialogFormVisible = val
    },
    handleFormSubmit(isRestore = false) {
      this.handleSubmit( )
    },

    handleSubmit() {
      this.loading = true
      console.log('aaaabbb')
      doUserRegQuery(this.queryTel)
        .then(res => {
          this.tabledata = res.data || []
          console.log('tableData', this.tabledata)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleAddDone( ) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm.init(this.CONSTAPP.CTRL_FLAG.CREATE, {})
      })
    },
    getloadFile() {
      console.log('loadFile')
      //请求后台接口
      var downFile = {}
      downFile.attachmenttitle = '用水申请表'
      downFile.extend = 'docx'
      downFile.fileId = 'USERREGADD'
      downLoadFile(downFile)
      .then((data) =>{
          //拿到文件blob
          if( data.size < 0 ) {
              Dialog({ message: '文件不存在或为空,请联系管理人员' });
              return
          }
          console.log('data', data.size)
          // let blob = new Blob([data])
          //定义下载文件名
          let fileName = downFile.attachmenttitle + "." + downFile.extend;
          //判断IE保存方法还是其他浏览器保存方法
          if ('download' in document.createElement('a')) {
              //将blob传出获取文件下载地址
              var url = window.URL.createObjectURL(data);
              //定义一个a标签
              var a = document.createElement('a');
              a.style.display = 'none';
              //将下载地址赋值给a标签的href
              a.href = url;
              //将下载文件的名字赋值给a标签的download
              a.download = fileName;
              //添加到body中
              document.body.appendChild(a)
              //调用a标签的点击方法
  　          a.click();
              setTimeout(() => {
                  window.URL.revokeObjectURL(url); // 释放URL 对象
                  document.body.removeChild(a);	//移除a标签
              }, 1000);  //解决部分浏览器下载时“无此文件”问题

          } else {
              navigator.msSaveBlob(blob, fileName)
          }
      })
      .catch(function (error) {
          console.log(error);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 20px;
}
.text > h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text > h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
}
.text > h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  margin-bottom: 38px;
}
/*问卷调查插件*/
.demonstration {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 9px;
}
.question-headline {
  font-size: 16px !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 1) !important;
  line-height: 54px !important;
  display: block !important;
}
.question-title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 44px;
}
/deep/ .el-textarea__inner {
  min-height: 158px !important;
}
/deep/ .el-button--danger {
  margin-top: 40px !important;
  margin-left: 26px;
  width: 112px;
  height: 38px;
  background: rgba(221, 33, 38, 1);
  border-radius: 4px;
}
/deep/ .el-radio__label {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
}
</style>